import { SliderResponsive } from "../cmsmodules/sliderresponsive";
import { TextModuleToggler } from "../cmsmodules/textModuleToggler";
import { ImagesMultiColumn } from "../cmsmodules/imagesmulticolumn";
import {SlDialog} from "../../../../../clxFrontendCms/public/js/shoelace/shoelace";
import {ScriptDispatcher} from "../common/scriptDispatcher";

export class DialogManager {
    private dialog: SlDialog | null;

    constructor() {
        this.dialog = document.querySelector<SlDialog>('.detail-dialog');
        if (this.dialog) {
            this.init();
        }
    }

    private init(): void {
        // der click event wird auf das document gesetzt, damit auch dynamisch hinzugefuegte elemente reagieren
        document.addEventListener('click', this.handleClick.bind(this));

        this.dialog?.addEventListener('sl-after-hide', (evt) => {
            if (evt.target !== this.dialog) {
                return;
            }

            this.afterHide();
        });
    }

    private afterHide(): void {
        const dialogContent = this.dialog?.querySelector('.dialog-content');
        if (dialogContent) {
            dialogContent.innerHTML = '';
            this.dialog!.className = 'detail-dialog';
        }

    }

    private handleClick(event: Event): void {
        let dialogOpener = event.target as HTMLElement;
        if (!dialogOpener) {
            return;
        }

        dialogOpener = dialogOpener.classList.contains('detail-dialog-opener')
            ? dialogOpener
            : dialogOpener.closest('.detail-dialog-opener') as HTMLElement;

        // wenn es kein Dialog Link ist, dann abbrechen
        if (!dialogOpener || !this.dialog) {
            return;
        }

        event.preventDefault();

        // Uberschrift im Dialog setzen by injection
        const dialogSlot = this.dialog.querySelector('[slot=label]');
        if (dialogSlot && dialogOpener.dataset.title !== undefined) {
            dialogSlot.innerHTML = dialogOpener.dataset.title || '';

            if (dialogOpener.dataset.class) {
                this.dialog.classList.add(dialogOpener.dataset.class);
            }

            if (!dialogOpener.dataset.detailUrl) {
                return;
            }
            
            
            
            // Details abhaengig von uebergebener Url fetchen
            fetch(dialogOpener.dataset.detailUrl, {
                headers: { "X-Requested-With": "XMLHttpRequest" },
                method: 'GET',
                credentials: "same-origin",
            })
                .then(response => response.text())
                .then(content => {
                    // Dialog Body mit content befuellen
                    const dialogContent = this.dialog?.querySelector('.dialog-content');
                    if (dialogContent) {
                        dialogContent.innerHTML = content;

                        // cms module neu instialisieren, da im layer auch cms module sein koennten
                        new SliderResponsive(dialogContent);
                        new ImagesMultiColumn(dialogContent);
                        new TextModuleToggler(dialogContent);
                        const dispatcher = new ScriptDispatcher();
                        dispatcher.dispatchScriptTag(content);
                        dispatcher.dispatchScriptFiles(content);

                    }
                });

            this.dialog.show();
        }
    }
}

